import React from 'react';

const ProductDesiField = ({ desi, onChange, className = "" }) => {
    return (
        <div className={`space-y-2 ${className}`}>
            <label className="block text-sm font-medium text-gray-700">
                Desi Bilgisi
            </label>
            <div className="relative">
                <input
                    type="number"
                    step="0.1"
                    min="0.1"
                    max="30"
                    value={desi || ''}
                    onChange={(e) => onChange(parseFloat(e.target.value) || 1.0)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="1.0"
                />
                <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                    <span className="text-gray-500 text-sm">desi</span>
                </div>
            </div>
            <p className="text-xs text-gray-500">
                Ürünün kargo desisi (0.1 - 30.0 arası). Kargo fiyatı hesaplamasında kullanılır.
            </p>
        </div>
    );
};

export default ProductDesiField;